import styled from 'styled-components'

export const SearchInputWrapper = styled.div`
  width: 100%;

  .ant-input {
    height: 47px;
    font-size: 14px;
    border: 1px solid #eeeeee;
    border-radius: 8px;
    outline: none;
    padding: 16px;
    width: 100%;
    position: relative;
    background-color: #fff;
    line-height: 21px;
    color: #999999;

    &:focus {
      background-color: #fff;
      outline: none;
      color: #646877;
      box-shadow: none;
    }
    &:active {
      background-color: #fff;
      outline: none;
      color: #646877;
    }

    @media (max-width: 576px) {
      border: none;
      padding: 0;
      margin: 0;
    }
  }
`
